import React from "react";
import { Container, Alert, Button } from "react-bootstrap";

function HomeBanner() {
  return (
    <section aria-labelledby="home-banner-heading" className="mb-4">
      <Container>
        <Alert
          variant="info"
          role="region"
          aria-live="polite"
          aria-label="Upcoming news banner"
          className="d-flex align-items-center justify-content-between flex-column flex-md-row"
        >
          <div className="me-3">
            <h2 id="home-banner-heading" className="mb-1 text-accent fw-bold">[ 30% First Round PRE-SALE DISCOUNT ]</h2>
            <p className="mb-1 fw-bold">SECURE THE FOUNDATION.</p>
            <p className="mb-0">Join the Sovereign Economy at the lowest entry point. Express your interest here. 🏛️🛡️</p>
          </div>

          <div className="mt-3 mt-md-0">
            <Button
              as="a"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfnRbDnm61M8kAUOQF9uSZMWZyspBXUNvKbA-t6Ml9ARog3_A/viewform?usp=sharing&ouid=103015240996433302632"
              target="_blank"
              rel="noopener noreferrer"
              variant="light"
              className="fw-bold text-accent"
              aria-label="Open pre-sale interest form (opens in new tab)"
            >
              REGISTER FOR PRE-SALE
            </Button>
          </div>
        </Alert>
      </Container>
    </section>
  );
}

export default HomeBanner;
